import React, {useCallback, useEffect, useState} from "react";

import "./vehicle.scss";
import "../Button/powertrainToolTip.scss";
import '../modal_selector/trimModal/trimModal.scss';
import {useDispatch, useSelector} from 'react-redux';
import {
    defaultAccordionSegment,
    fetchTrimData,
    fetchVehicleData,
    getClientprofile,
    getDefaultAccordionSegment,
    getDefaultDriveTpes,
    getDriveTypes,
    getExteriorColorCode,
    getSegments,
    getSelectedYear,
    getSortedCompareTrims,
    getTrimModels,
    filterVehiclesFromPriceRange,
    filterVehiclesOnSubmit,
    getVehiclesByYear,
    getVehicleTypesName,
    getYears,
    priceRange,
    selectedSegment,
    setActiveLanguage,
    setActiveLocale,
    setBaseGroup,
    setPrimaryVehicle,
} from '../../slices/vehicleSlice';

import Navbar from '../nav/Navbar';
import YearToggle from '../Button/YearToggle';
import FilterToggle from '../Button/FilterToggle';
import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate} from "react-router-dom";
import {currencyConverter} from "../../utility/methods";
import {
    getActiveLanguage,
    getActiveLocaleImage,
    getVehicleImage,
    getVehicleModelYear,
    getVehicleName
} from "./vehicle.utility";
import {trackSelectVehicle, trackVehicleModelSelected, trackPageViewEngagement, trackUserEngagement  } from "../GoogleTagManager.utils";
import VehiclesAccordion from "./VehiclesAccordion";
import TrimModal from "../modal_selector/trimModal/TrimModal";
import PowerTrainType from "../Button/PowerTrainType";
import {isMobile} from "react-device-detect";


const Vehicle = (props) => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const selectedSegments = useSelector(selectedSegment);
    const filteredPriceRange = useSelector(priceRange)
    const vehiclesBySegment = useSelector(filterVehiclesOnSubmit);
    let filteredVehiclesFromPriceRange = useSelector(filterVehiclesFromPriceRange);
    let vehicleSegments = useSelector(getSegments);

    const years = useSelector(getYears);
    const baseGorup = useSelector(setBaseGroup);
    const vehiclesTrim = useSelector(getTrimModels);
    const driveTypes = useSelector(getDriveTypes);
    const defaultType = useSelector(getDefaultDriveTpes)
    const vehicleTypeName = useSelector(getVehicleTypesName);
    const trimType = useSelector(getSortedCompareTrims);
    const activeLocal = useSelector(setActiveLocale);
    const [trimVehicle, setTrimType] = React.useState('');
    const getTrimData = useSelector(getVehiclesByYear);
    const getYear = useSelector(getSelectedYear);
    const [open, setOpen] = React.useState(false);
    const [vehicleImage, setVehicleImage] = React.useState('');
    const [modelName, setModelName] = React.useState('');
    const [modelYear, setModelYear] = React.useState('');
    let defaultSegment = useSelector(defaultAccordionSegment)
    const baseGroup = useSelector(setBaseGroup);
    const [checked, setChecked] = React.useState(false);
    let [defaultYear, setDefaultYear] = React.useState('')
    const [expandedSegment, setExpandedSegment] = React.useState(defaultSegment[0]);
    const [selectedVehicleCode, setSelectedVehicleCode] = React.useState(null);
    const [vehicleCode, setVehicleCode] = React.useState(null);
    const [draggingSlider, setDraggingSlider] = React.useState(false);
    const [isVehicleTypeSelected, setVehicleType] = React.useState(false);
    const handleSegmentChange = (id) => (event, newExpanded) => {
        if (newExpanded) {
            // if the clicked accordion is being expanded, add it to the array
            setExpandedSegment((prevExpanded) => [...prevExpanded, id]);
        } else {
            // if the clicked accordion is being collapsed, remove it from the array
            setExpandedSegment((prevExpanded) => prevExpanded.filter((arr) => arr !== id));
        }
    };

    const handleTrimChange = useCallback((event) => {
        const { value } = event.target;
        setTrimType(value);
        setSelectedVehicleCode(null);
        setVehicleCode(null);
    }, [setTrimType, setSelectedVehicleCode, setVehicleCode]);

    const compareTrim = (code, media, vehicle, secondaryTrims) => {
        let defaultColorCode = null;
        if (media) {
            const colorKeys = Object.keys(media);
            if (colorKeys[0] === "NO_COLOR" && colorKeys.length > 1) {
                defaultColorCode = colorKeys[1];
            } else {
                defaultColorCode = colorKeys[0];
            }
        }

        let countryPath = '';
        if (props.country) {
            countryPath = props.country + '/';
        }
        if (props.language !== 'en'){
            countryPath = countryPath + props.language + '/';
        }
        let url = `/${props.client}/${countryPath}compare/features/${code}`
        if (secondaryTrims?.length) {
            const sortedTrims = secondaryTrims.filter(item => item !== code).slice(0,3);
            if (sortedTrims.length) {
                url += `/${sortedTrims.join('-')}`;
            }
        }
        navigate(url, { replace: true });

        dispatch(getExteriorColorCode(defaultColorCode));
        dispatch(setPrimaryVehicle(code));

        trackSelectVehicle(vehicle,baseGorup)
    };

    const handleClose = () => {
        setTrimType('')
        setOpen(false)
        setChecked(false)
        setVehicleImage('')
        setModelName('');
        setModelYear('');
        setSelectedVehicleCode(null)
        setVehicleCode(null)
    }
    const useQuery = () => {
        const {search} = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }
    let query = useQuery()
    const handleOpen = () => {
        setOpen(true)
        setChecked(true)
    };

    useEffect(() => {
        setDefaultYear(years[0])
    }, [years])

    useEffect(() => {
        setExpandedSegment([defaultSegment[0]]);
    }, [getYear, defaultSegment]);

    useEffect(() => {
        if (window.location.pathname.includes('/us/')) {
            const newUrl = window.location.pathname.replace('/us/', '/');
            window.history.replaceState({}, '', newUrl);
        }
    }, []);

    useEffect(() => {
        if (query.get('model') !== null && (query.get('model').length === 10 || query.get('model').length === 5) && getTrimData.length && query.get('model')) {
            const modelCode = query.get('model');
            dispatch(fetchTrimData(modelCode));
        }
    }, [getTrimData]);

    useEffect(() => {
        if (query.get('model') !== null && (query.get('model').length === 10 || query.get('model').length === 5) && getTrimData.length) {
            const modelCode = query.get('model');
            if (vehiclesTrim && vehiclesTrim.length && modelCode) {
                setModelName(getVehicleName(modelCode, getTrimData));
                setModelYear(getVehicleModelYear(modelCode, getTrimData));
                setVehicleImage(getVehicleImage(modelCode, getTrimData, activeLocal));
                handleOpen();
            }
        }
    }, [vehiclesTrim]);

    useEffect(() => {
        if (defaultType && defaultType.VEHICLE_TYPE.length) {
            getDefaultDriveType()
        }
    }, [driveTypes])

    function fireUserEngagementEvent(baseGroup,locale) {
        window.addEventListener('beforeunload', () => {
            trackUserEngagement(baseGroup,locale)
        });
    }

    useEffect(() => {
        const prevClient = sessionStorage.getItem("prevClient");
        const prevLanguage = sessionStorage.getItem("prevLanguage");
        const prevCountry = sessionStorage.getItem("prevCountry");
        sessionStorage.removeItem("featureSearch");
        if (props.client === prevClient && props.language === prevLanguage && props.country === prevCountry) {
            const storedData = sessionStorage.getItem("storedData");
            if (storedData) {
                const { akanaAppId, profileKey, supportedLanguages,customerKey, lockedCompetitors } = JSON.parse(storedData);
                const locale = getActiveLanguage(props.language, supportedLanguages);
                dispatch(setActiveLanguage(locale));
                dispatch(fetchVehicleData({ akanaAppId, profileKey, locale, customerKey, lockedCompetitors}));
            } else {
                dispatch(getClientprofile(props)).then((result) => {
                    if (!result.payload) return;
                    const { akanaAppId, profileKey, supportedLanguages, customerKey, lockedCompetitors } = result.payload;
                    const locale = getActiveLanguage(props.language, supportedLanguages);
                    dispatch(setActiveLanguage(locale));
                    dispatch(fetchVehicleData({ akanaAppId, profileKey, locale, customerKey, lockedCompetitors }));
                    fireUserEngagementEvent(baseGroup,locale)
                    trackPageViewEngagement(baseGroup,locale)
                    sessionStorage.setItem("prevClient", props.client);
                    sessionStorage.setItem("prevLanguage", props.language);
                    sessionStorage.setItem("prevCountry", props.country);
                    sessionStorage.setItem("storedData", JSON.stringify({  supportedLanguages, lockedCompetitors }));
                });
            }
        }else{
            sessionStorage.clear();
            dispatch(getClientprofile(props)).then((result) => {
                if (!result.payload) return;
                const { akanaAppId, profileKey, supportedLanguages, customerKey, lockedCompetitors } = result.payload;
                const locale = getActiveLanguage(props.language, supportedLanguages);
                dispatch(setActiveLanguage(locale));
                dispatch(fetchVehicleData({ akanaAppId, profileKey, locale, customerKey, lockedCompetitors }));
                fireUserEngagementEvent(baseGroup,locale)
                trackPageViewEngagement(baseGroup,locale)
                sessionStorage.setItem("prevClient", props.client);
                sessionStorage.setItem("prevLanguage", props.language);
                sessionStorage.setItem("prevCountry", props.country);
                sessionStorage.setItem("storedData", JSON.stringify({ supportedLanguages, lockedCompetitors }));
            });
        }
    }, [props.client, props.language, props.country]);

    const onTileClick = async (event, mediaToDisplay, model, year,pricing) => {
        setTrimType('')
        trackVehicleModelSelected(baseGorup, pricing)
        const vehicleCode = event.currentTarget.id;
        await dispatch(fetchTrimData(vehicleCode))
        setVehicleImage(mediaToDisplay)
        setModelName(model);
        setModelYear(year);
        handleOpen()
    }

    const getDefaultDriveType = () => {
        let driveTypeObj = []

        if (defaultType.VEHICLE_TYPE_NAME === 'WHEEL_BASE') {
            let wheel_base = [...defaultType.VEHICLE_TYPE]
            let order = (wheel_base.sort((a, b) => a - b))
            let defaultSortType = (Math.min(...order))
            setTrimType(defaultSortType.toString())
        }
        else if (defaultType.VEHICLE_TYPE_NAME === "DRIVE_TYPE"){
            setTrimType( defaultType.VEHICLE_TYPE[0])
        }
        else if (defaultType){
            defaultType.VEHICLE_TYPE.forEach((type) => {
                const filterType = vehiclesTrim.filter(vehicle => vehicle.features[vehicleTypeName] === type)
                driveTypeObj = [...driveTypeObj, filterType]
                const length = driveTypeObj.map((a) => a.length)
                const arrayIndex = length.indexOf(Math.max(...length))
                setTrimType(driveTypeObj[arrayIndex][0]?.features[vehicleTypeName])
            })
        }
    }

    const buildTilePricing = (pricing) => {
        const {minMsrp, maxMsrp} = pricing;

        if (!!minMsrp && !!maxMsrp) {
            return (
                <React.Fragment>
                    {currencyConverter(minMsrp,activeLocal)} * <span> - </span> {currencyConverter(maxMsrp,activeLocal)}*
                </React.Fragment>
            );
        }

        return ("");
    }

    const buildTile = (vehicle, _index) => {
        const {media, year, model, pricing, code, powertrain} = vehicle;
        let mediaToDisplay = null;
        let mediaObject = null;

        if (!!media) {
            const mediaCode = Object.keys(media)[0];
            if (!!mediaCode) {
                mediaObject = mediaCode;
                const angleShot = Object.keys(media[mediaCode])[0];
                if (!!angleShot && typeof media[mediaCode][angleShot].url === "string" && media[mediaCode][angleShot].url.length > 0) {
                    mediaToDisplay = media[mediaCode][angleShot].url;
                }
            }
        }

        return (
            <div className={'tiles'} key={`${code}-${mediaObject}`} id={`${code}`}
                 onClick={(e) => onTileClick(e, mediaToDisplay ? mediaToDisplay : getActiveLocaleImage(activeLocal), model, year, pricing)}>
                <div className="accordion-data">
                    <div className="figure">
                        <img src={!!mediaToDisplay ? mediaToDisplay : getActiveLocaleImage(activeLocal)} alt={code}/>
                    </div>
                    {!isMobile &&
                    <div className="powertrain-icon">
                        <PowerTrainType powertrain={powertrain}
                                        index = {_index}>

                        </PowerTrainType>
                    </div>
                    }
                    <div className="model-year">
                        {year} {model}
                    </div>
                    <div className="model-price">
                        <span> {t('MSRP')} </span>
                        {
                            !!pricing ? buildTilePricing(pricing) : ""
                        }
                    </div>
                </div>
            </div>
        );
    };

    function showDefaultSegment(id) {
        if (!defaultSegment.includes(id)) {
            dispatch(getDefaultAccordionSegment(id))
        }
    }

    const buildVehicleSections = () => {
        return (
            <div className='segment-selector'>
                {
                    years && <VehiclesAccordion vehiclesBySegment={vehiclesBySegment}
                                                vehicleSegments={vehicleSegments}
                                                expandedSegment={expandedSegment}
                                                handleSegmentChange={handleSegmentChange}
                                                buildTile={buildTile}
                                                t={t}
                                                filteredPriceRange={filteredPriceRange}
                                                selectedSegments={selectedSegments}
                                                showDefaultSegment={showDefaultSegment}
                    />
                }
            </div>
        );
    };

    const showSelector = () => {
        return (
            <div className={'selector-overlay'}>
                <label>{t(vehicleTypeName)}</label>
                <select value={trimVehicle} className={'form-control-div'} name="trimSelector" id="trimSelector"
                        onChange={handleTrimChange}>
                    {
                        defaultType.VEHICLE_TYPE.map((trimType) => (
                                <option value={trimType} key={trimType}>{trimType}</option>
                            )
                        )
                    }
                </select>
            </div>
        )
    }

    return (
        <React.Fragment>
            <Navbar
                leftChildren={(
                    <div className="navbar-heading">{t('navigation.heading')}</div>
                )}
                rightChildren={(
                    <React.Fragment>
                        <YearToggle years={years}
                                    defaultYear={defaultYear}/>
                        <div className={'filter-button'}>
                            <FilterToggle
                                LOCALE = {activeLocal}
                                filteredVehiclesFromPriceRange ={ filteredVehiclesFromPriceRange}
                                draggingSlider = {draggingSlider}
                                setDraggingSlider = {setDraggingSlider}
                                setVehicleType = {setVehicleType}
                                isVehicleTypeSelected = {isVehicleTypeSelected}
                            />
                        </div>
                    </React.Fragment>
                )}
            />
            {years && buildVehicleSections()}
            {years && vehiclesTrim.length >=1  && <TrimModal vehicleTypeName={vehicleTypeName}
                                                            open={open}
                                                            handleClose={handleClose}
                                                            checked={checked}
                                                            vehicleImage={vehicleImage}
                                                            modelName={modelName}
                                                            modelYear={modelYear}
                                                            activeLocal={activeLocal}
                                                            showSelector={showSelector}
                                                            t={t}
                                                            defaultType={defaultType}
                                                            vehiclesTrim={vehiclesTrim}
                                                            trimVehicle={trimVehicle}
                                                            compareTrim={compareTrim}
                                                            trimType={trimType}
                                                            selectedVehicleCode={selectedVehicleCode}
                                                            setSelectedVehicleCode={setSelectedVehicleCode}
                                                            setVehicleCode={setVehicleCode}
                                                            vehicleCode={vehicleCode}

            />
            }
        </React.Fragment>
    )
};

export default Vehicle;
